/* import __COLOCATED_TEMPLATE__ from './posting-create-coordination.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, get, setProperties } from '@ember/object';

class PostingCreateCoordinationComponent extends Component {
  @service('states/routes/posting-create')
  state;

  @service
  session;

  get areFormElementsDisabled() {
    return this.state.areFormElementsDisabled;
  }

  get errors() {
    return get(this.state, 'errors');
  }

  get productionOptions() {
    const options = (this.args.productions ?? []).map((model) => ({ key: model.title, value: model }));
    options.unshift({ key: 'None', value: null });

    return options;
  }

  get selectedProductionTitle() {
    return get(this.state, 'updatedProduction.title') ?? 'None';
  }

  get showTeamOptions() {
    const allTeams = this.state.availableCompanyTeams;
    const currentUsersTeams = this.state.userIdToCompanyTeamsMap[this.session.currentUser.id];

    return this.state.currentUserIsCompanyAdminOrAdmin
      ? allTeams.length > 0
      : currentUsersTeams.length > 0;
  }

  get showProductions() {
    return Boolean(this.args.productions?.length > 0);
  }

  get teamOptions() {
    return this.state.companyTeamOptions.map((option) => ({
      value: option.value,
      key: option.title,
    }));
  }

  get updatedCompanyTeamName() {
    return get(this.state, 'updatedCompanyTeam.name') ?? 'None';
  }

  @action
  handleTeamSelected({ value }) {
    setProperties(this.state, {
      errors: {
        ...this.errors,
        company_team_id: undefined,
      },
      updatedCompanyTeam: this.state.availableCompanyTeams.find(({ id }) => id == value) ?? null,
    });
  }

  @action
  updateSelectedProduction({ value }) {
    setProperties(this.state, {
      errors: {
        ...this.errors,
        production_id: undefined,
      },
      updatedProduction: value,
    });
  }
}

export default PostingCreateCoordinationComponent;
